import React, { useState, useEffect } from 'react';
import Drawer from 'Components/Drawer';
import EnvironmentManager from 'Utils/environmentManager';
import Input from 'Components/Input';
import { useDispatch, useSelector } from 'react-redux';
import {
  sendVerificationEmail,
  updatePersonalInformationsEmail,
  ignoreEmailVerification,
  getCommunicationSettings
} from 'Store/actions';
import Icon from 'Components/Icon';
import PropTypes from 'prop-types';
import { withMixpanel } from 'Utils/mixpanel';
import History from 'Store/history';
const STEPS = {
  CHOOSE_ADDRESS: 'CHOOSE_ADDRESS',
  NEW_EMAIL: 'NEW_EMAIL',
  LINK_SENDED: 'LINK_SENDED',
  CONTACT_PERMISSION: 'CONTACT_PERMISSION'
};

const EmailVerificationModal = ({ open, mixpanel }) => {
  const [openDrawer, setOpenDrawer] = useState(open);

  const [newEMail, setNewEMail] = useState('');

  const { data: { email } } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const { data: { campaignEmail, campaignSms, campaignCallCenter }, isFetched: campaignInfoFetched  } = useSelector(state => state.communicationSettings);
  const [step, setStep] = useState(STEPS.CHOOSE_ADDRESS);
  const CMS_TITLE_EMAIL_VALIDATION_ACTION_SHET = EnvironmentManager.getMessageText({ key: 'title_email_validation_actionsheet' }) || 'E-posta Adresini Doğrula';
  const CMS_DESC_TITLE_EMAIL_VALIDATION_ACTION_SHET = EnvironmentManager.getMessageText({ key: 'description_email_validation_actionsheet' }) || 'Sistemde kayıtlı e-posta adresini hemen doğrula, en güncel fırsat ve kampanyaları kaçırma!';
  const CMS_DESC_EMAIL_VALIDATION_ACTION_SHET = EnvironmentManager.getMessageText({ key: 'description_email_verified_actionsheet' })?.replace('%@', email);
  const CMS_NEW_NUMBER_VALIDATION_CODE = EnvironmentManager.getMessageText({ key: 'button_new_email_validation_code_actionsheet' }) || 'Yeni Numara Gir';
  const CMS_UP_TO_DATE_VALIDATON = EnvironmentManager.getMessageText({ key: 'button_adress_up_to_date_validation_actionsheet' }) || 'Adresim Güncel';
  const CMS_DESC_VALIDATION_LINK =  EnvironmentManager.getMessageText({ key: 'description_validation_link_actionsheet' })?.replace('%@', newEMail ? newEMail : email);
  const CMS_BUTTON_DONE =  EnvironmentManager.getMessageText({ key: 'button_done_actionsheet' }) || 'Tamam';
  const CMS_EMAIL_VALIDATION_BOX =  EnvironmentManager.getMessageText({ key: 'description_email_validation_box' }) || 'E-posta';
  const CMS_VALIDATION_LINK_ACTIONSHEET =  EnvironmentManager.getMessageText({ key: 'button_validation_link_actionsheet' }) || 'Aktivasyon Linki Gönder';
  const CMS_TITLE_ONE_LAST_TRANSACTION_ACTIONSHEET =  EnvironmentManager.getMessageText({ key: 'title_one_last_transaction_actionsheet' }) || 'Son Bir İşlem Kaldı!';
  const CMS_BUTTON_CONTACT_PERMISSION =  EnvironmentManager.getMessageText({ key: 'button_contact_permission' }) || 'İletişim İzinlerini Düzenle';
  const CMS_EMAIL_ONE_LAST_TRANSACTION =  EnvironmentManager.getMessageText({ key: 'description_email_one_last_transaction_actionsheet' });
 
  
  const isEmailChanged =  newEMail !== email;
  const onChangeEmail = e => {
    setNewEMail(e.target.value);
  };

  const clearInput = () => {
    setNewEMail('');
  };

  const onSubmitEmail = async () => {
    try {

      if (email !== newEMail) {
        await dispatch(updatePersonalInformationsEmail(newEMail));
      } else {
        await dispatch(sendVerificationEmail());
      }
      setStep(STEPS.LINK_SENDED);
      let obj = {};
      if (email === newEMail) {
        obj = {
          'Adjustment Status': email === newEMail,
          'Old e-mail': email,
        };
      } else {
        obj = {
          'Adjustment Status': email === newEMail,
          'New e-mail': newEMail
        };
      }
      mixpanel.track('Click Send Activation Link Button', obj);
    } catch (e) {
      console.log('EMAIL SEND AND UPDATE FAILED');
    }
  };

  const content = () => {
    switch (step) {
      case STEPS.CHOOSE_ADDRESS:
        return <div className='email-verification__chose-address' dangerouslySetInnerHTML={ { __html: CMS_DESC_EMAIL_VALIDATION_ACTION_SHET } } />;
      case STEPS.NEW_EMAIL:
        return <div className='email-verification__new-email'>
          <div className='email-verification__new-email__content' dangerouslySetInnerHTML={ { __html: CMS_DESC_TITLE_EMAIL_VALIDATION_ACTION_SHET } } />
          <div className='email-verification__new-email__input'>
            <Input
              name={ CMS_EMAIL_VALIDATION_BOX }
              id="email"
              value={ newEMail }
              autoFocus
              type='text'
              onChange={ onChangeEmail }
              clearInput={ isEmailChanged ? clearInput : null }
              append={ !isEmailChanged && (
                <Icon iconName="svgCheckGreen" />
              ) }
            />
          </div>
        </div>;
      case STEPS.LINK_SENDED: {
        return <div className='email-verification__link-sended'>
          <div className='mb-2' dangerouslySetInnerHTML={ { __html: CMS_DESC_VALIDATION_LINK } } />
        </div>;
      }
      case STEPS.CONTACT_PERMISSION: {
        return (<div className='phone-verification__contact' dangerouslySetInnerHTML={ { __html: CMS_EMAIL_ONE_LAST_TRANSACTION } } />);
      }

    }
  };

  const title = () => {
    switch (step) {
      case STEPS.CONTACT_PERMISSION:
        return CMS_TITLE_ONE_LAST_TRANSACTION_ACTIONSHEET;
      default:
        return CMS_TITLE_EMAIL_VALIDATION_ACTION_SHET;
    }
  };

  const onCloseHandler = async () => {
    try {
      setOpenDrawer(false);
      dispatch(ignoreEmailVerification());
    } catch (error) {
      console.log('OTP ACTION SHEET INGORE PUT ERROR');
    }
  };


  const icon = () => {
    switch (step) {
      case STEPS.CONTACT_PERMISSION:
        return <Icon iconName="svgThumpsUp" />;
      default:
        return null;
    }
  };


  const buttons = () => {
    switch (step) {
      case STEPS.CHOOSE_ADDRESS:
        return {
          primaryButton: {
            label: CMS_UP_TO_DATE_VALIDATON,
            onClick: () => {
              onSubmitEmail();
            }
          },
          secondaryButton: {
            label: CMS_NEW_NUMBER_VALIDATION_CODE,
            onClick: () => {
              setStep(STEPS.NEW_EMAIL);
            }
          },
        };
      case STEPS.LINK_SENDED:
        return {
          primaryButton: {
            label: CMS_BUTTON_DONE,
            onClick: () => {
              if (!campaignEmail && !campaignSms && !campaignCallCenter && campaignInfoFetched) {
                setStep(STEPS.CONTACT_PERMISSION);
                mixpanel.track('View One Last Transaction Left Sheet');
              } else {
                onCloseHandler();
              }
            }
          },
        };

      case STEPS.NEW_EMAIL:
        return {
          primaryButton: {
            label: CMS_VALIDATION_LINK_ACTIONSHEET,
            className: 'btn btn--primary btn--block',
            onClick: () => {
              onSubmitEmail();
            }
          },
        };
      case STEPS.CONTACT_PERMISSION:
        return {
          primaryButton: {
            label: CMS_BUTTON_CONTACT_PERMISSION,
            className: 'btn btn--primary btn--block',
            onClick: () => {
              History.push('/ayarlar/iletisim-izinleri');
              mixpanel.track('Click Edit Contact Permission Button');
              onCloseHandler();
            }
          },
        };
    }
  };

  useEffect(() => {
    if (email) {
      setNewEMail(email);
    }
  }, [email]);

  useEffect(() => {
    if (openDrawer) {
      mixpanel.track('View Validation Window');
      dispatch(getCommunicationSettings());
    }
  }, [openDrawer]);

  useEffect(() => {
    if (open) {
      setOpenDrawer(open);
    }
  }, [open]);

  return <Drawer icon={ icon() } open={ openDrawer } onClose={ onCloseHandler } title={ title() } buttonArea={ buttons() }>
    { content() }
  </Drawer>;
};

EmailVerificationModal.propTypes = {
  open: PropTypes.bool,
  mixpanel: PropTypes.object,
};

export default withMixpanel(EmailVerificationModal);
